var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardsSendSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 14.6667H10C13.3333 14.6667 14.6667 13.3333 14.6667 10V6C14.6667 2.66667 13.3333 1.33333 10 1.33333H6C2.66667 1.33333 1.33333 2.66667 1.33333 6V10C1.33333 13.3333 2.66667 14.6667 6 14.6667Z",
    stroke: "#562809",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6 6.34L8 4.34L10 6.34",
    stroke: "#562809",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8 4.34V9.67333",
    stroke: "#562809",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4 11.0067C6.59333 11.8733 9.40667 11.8733 12 11.0067",
    stroke: "#562809",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0,
    d: "M15.5 0.5V15.5H0.5V0.5H15.5Z",
    stroke: "#562809"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsSendSquare);
export default __webpack_public_path__ + "static/media/rewards-send-square.0f5c2cc63e8c634702281b5e4332f605.svg";
export { ForwardRef as ReactComponent };